export const normalizeNodeNumber = (value: number): number => {
  const num = Number(value);

  if (!Number.isInteger(num)) {
    throw new Error(`nodeNumber is not integer: ${value}.`);
  }

  // The bound is JAVASCRIPT's, not the column's.
  //
  // A comment here used to say the limit came from GraphQL `Int` being 32-bit.
  // It does not: the save path writes
  // `Tenancy_Solution_Version_Nodes_Ps_Insert_Input.nodeNumber`, typed
  // `Scalars['numeric']` — Postgres `numeric`, arbitrary precision. The four
  // `Scalars['Int']` declarations of a `nodeNumber` in the generated schema all
  // belong to `Tenancy_Template_Node_*`, a different table this path never
  // writes. Narrowing to 2^31 on that reading would have refused to publish
  // solutions whose numbers sit in 2^31..2^53 — values the backend accepts and
  // that reach the table through CSV import today (PSTUDIO-3990).
  //
  // What genuinely breaks first is the client: past `MAX_SAFE_INTEGER` two
  // different strings parse to the SAME double, so `'9007199254740993'` and
  // `'9007199254740992'` become indistinguishable — which is why the duplicate
  // detector rejects them as node numbers at all (`toNodeNumberIdentity`). A
  // number this large cannot be compared, renumbered or round-tripped
  // truthfully, so it is refused here rather than silently altered.
  if (!Number.isSafeInteger(num)) {
    throw new Error(
      `Node number must be between ${Number.MIN_SAFE_INTEGER.toLocaleString('en-US')} and ${Number.MAX_SAFE_INTEGER.toLocaleString('en-US')}.`
    );
  }

  return num;
};
